import React from "react";
import { useGlobalContext } from "../../context";
import Book from "../BookList/Book";
import Loader from "../Loader/Loader";
import coverImg from "../../Assets/images/nocover.png";
import "./BookList.css";

const BookList = () => {
  const { books, loading, resultTitle } = useGlobalContext();

  const booksWithCovers = books.map((singleBook) => {
    const coverUrl = singleBook.cover_id
      ? `https://covers.openlibrary.org/b/id/${singleBook.cover_id}-S.jpg`
      : coverImg;

    return {
      ...singleBook,
      // Using the .replace method to remove the /works/ prefix from the id property in books array
      id: singleBook.id.replace("/works/", ""),
      cover_img: coverUrl,
    };
  });

  console.log(booksWithCovers);

  if (loading) return <Loader />;

  return (
    <section className="booklist">
      <div className="container">
        <div className="section-title">
          <h2>{resultTitle}</h2>
        </div>
        <div className="booklist-content grid">
          {booksWithCovers.slice(0, 30).map((item) => (
            <Book key={item.id} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BookList;
